import React, { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { setLoadingFalseAction, setLoadingTrueAction } from "../../../redux/actions/loadingActions/loadingActions";
import { refundTara } from "../../../services/userServices";

export const taraRefundAdminContext = createContext({
  reason: "",
  setReason: () => {},
  amount: 0,
  setAmount: () => {},
  invoice: null,
  setInvoice: () => {},
  handleRefund: () => {}
});

const TaraRefundAdminContext = ({ children }) => {
  const dispatch = useDispatch();
  
  const [reason, setReason] = useState("");
  const [invoice, setInvoice] = useState(null);
  const [amount, setAmount] = useState(0); 

  const handleRefund = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      return toastErrorMessage("لطفا دلیل استرداد را وارد کنید");
    }

    dispatch(setLoadingTrueAction());
    const objData = {
      reason: reason,
      amount: amount,
      invoice
    };
    
    try {
      const { data } = await refundTara(objData);
      toastSuccessMessage(data.message || "استرداد با موفقیت انجام شد");
      // Reload the page after 1.5 seconds so the admin can see the updated status
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      toastErrorMessage(error.response?.data?.error || "خطا در ارتباط با سرور");
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <taraRefundAdminContext.Provider
      value={{
        reason,
        setReason,
        amount,
        setAmount,
        invoice,
        setInvoice,
        handleRefund
      }}
    >
      {children}
    </taraRefundAdminContext.Provider>
  );
};

export default TaraRefundAdminContext;